var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.page,{tag:"component",attrs:{"tabInfo":_vm.tabInfo,"proCfg":_vm.productCfg,"editParams":_vm.editParams},on:{"on-edit-btn":_vm.handleEditBtn,"on-click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }